import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private moduleName: string = "User";

  url = environment.endpoint + "/api/" + this.moduleName;

  constructor(
    private http: HttpClient,

  ) {
  }

  
  getHeaders() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('authToken')
      })
    };
  }

  get(id:any) {
    const url = this.url + "/" + (id != undefined ? id : '');
    return this.http.get(url, this.getHeaders());
  }

  authenticate(info: any) {
    const url = this.url + '/Authenticate';
    return this.http.post(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }
  resetpassword(email: any) {
    let info:any = {};
    info.email = email;
    console.log(info.email)
    const url = this.url + '/reset';
    return this.http.post(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }
  resendvcode(){
      let info:any = {};
      info.userId = localStorage.getItem('id')
      console.log(info.userId)
      const url = this.url + '/resend-vcode';
      return this.http.post(url, info, this.getHeaders())
        .pipe(
          catchError(this.handleError)
        );
    
  }
  
  createAdmin(info) {
    const url = this.url + '/create/admin';
    return this.http.post(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  createAgent(info) {
    const url = this.url + '/create/agent';
    return this.http.post(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  createMerchant(info) {
    const url = this.url + '/create/merchant';
    return this.http.post(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  createReceptionist(info) {
    const url = this.url + '/create/receptionist';
    return this.http.post(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  getAdmins(){
    const url = this.url + '/admins';
    return this.http.get(url, this.getHeaders())
    .pipe(
      catchError(this.handleError)
    );
  }

  getAdmins_byBranch(id:any){
    const url = this.url + '/byBranch=' + id;
    return this.http.get(url, this.getHeaders())
    .pipe(
      catchError(this.handleError)
    );
  }

  getBranchDesignation(id:any) {
    const url = this.url + '/designation/byUser=' + id;
    
    return this.http.get(url, this.getHeaders())
    .pipe(
      catchError(this.handleError)
    );
  }

  handleError(error: HttpErrorResponse) {
    console.log(error);
    return throwError(error);
  }

  update(info:any) {
    const url = this.url + '/' + info.id;
    return this.http.put(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  update_portal(info:any) {
    const url = this.url + '/portal/' + info.id;
    return this.http.put(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  delete( id: string ) {
    const url = this.url + '/' + id;
    return this.http.delete(url, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  changePassword(info:any){
    const url = this.url + '/change-password';
    return this.http.post(url, info, this.getHeaders())
      .pipe(
        catchError(this.handleError)
      );
  }

  getRaffleEntries(hrs:any, pass:any) {
    const url = this.url + "/raffle/hrDiff=" + hrs + "/" + pass;
    return this.http.get(url, this.getHeaders());
  }
}